import { _BaseListButtonData, IListButtonData } from "./_base-list-button";

export class ListButtonAdd 
    extends _BaseListButtonData
{
    protected constructor(buttonData?: IListButtonData){
        super(buttonData ?? null)
    }

    static create(buttonData?: IListButtonData): ListButtonAdd {
        return new ListButtonAdd(buttonData);
    }
}
